import { isAdmin, isStrategyTeam, isPolicyTeam, isPortfolioTeam, isProjectTeam, isModerator } from '../rolesSvc';
import { status as PS } from '../../helpers/passport';

const FS = {
  created: 'created',
  onApprove: 'onApprove',
  rejected: 'rejected',
  approved: 'approved',
  excluded: 'excluded',
};

const canEdit = (userCtx, stratId, portfId, projId, policyId) =>
  isProjectTeam(userCtx, projId)
  || isPortfolioTeam(userCtx, portfId)
  || !portfId && isStrategyTeam(userCtx, stratId)
  || !portfId && !stratId && isPolicyTeam(userCtx, policyId)
  || !portfId && !stratId && !policyId && isModerator(userCtx)
  || isAdmin(userCtx);

const canApprove = (userCtx, stratId, portfId, projId, policyId) =>
  isPortfolioTeam(userCtx, portfId)
  || !portfId && isStrategyTeam(userCtx, stratId)
  || !portfId && !stratId && isPolicyTeam(userCtx, policyId)
  || !portfId && !stratId && !policyId && isModerator(userCtx)
  || isAdmin(userCtx);

const rules = {
  Delete: {
    isStatusOk: (status) => [FS.created, FS.rejected, FS.approved].includes(status),
    isRoleOk: canEdit,
    extra: (userCtx, status, projStatus) => ![PS.approved].includes(status) || isAdmin(userCtx), // если значение одобрено, удалять значения может только ПО
  },
  Edit: {
    isStatusOk: (status) => FS.excluded !== status,
    isRoleOk: canEdit,
    extra: (userCtx, status, projStatus) => ![PS.closed].includes(projStatus) || isAdmin(userCtx), // если проект закрыт, редактировать значения может только ПО
  },
  Send: {
    isStatusOk: (status) => [FS.created, FS.rejected].includes(status),
    isRoleOk: canEdit,
  },
  Reject: {
    isStatusOk: (status) => FS.onApprove === status,
    isRoleOk: canApprove,
  },
  Approve: {
    isStatusOk: (status) => FS.onApprove === status,
    isRoleOk: canApprove,
  },
  See: {
    isStatusOk: (status) => true,
    isRoleOk: canEdit,
  },
  Exclude: {
    isStatusOk: (status) => FS.approved === status,
    isRoleOk: canEdit,
  },
};

/**
 * @param {status} status 
 * @param {*} userCtx 
 * @param {?number} stratId 
 * @param {?number} portfId 
 * @param {?number} projId 
 * @param {?number} policyId 
 * @param {?string} projStatus 
 * @returns 
 */
export const getActionsModel = (status, userCtx, stratId, portfId, projId, policyId, projStatus = '') => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: rule.isStatusOk(status) && rule.isRoleOk(userCtx, stratId, portfId, projId, policyId) && (!rule?.extra || rule?.extra(userCtx, status, projStatus)),
}), {});
